/**
 * TODO: NEXUS V3.29.0
 * This component was partially implemented.
 * Workspaces cards have been hidden for Agency Reports and My Reports view.
 */
import React from 'react';
import { CardOptionsView } from '../../../Components/CardOptionsView/CardOptionsView';
import {
  CardOptionButton,
  CardOptionButtonProps
} from '../../../Components/CardOptionButton/CardOptionButton';
import { useHistory } from 'react-router-dom';
import { AppOptionsContext, SubscriptionContext } from 'ui-smartforce-settings';
import { CardOptionWorkspaceAds } from '../../../Components/CardOptionWorkspaceAds/CardOptionWorkspaceAds';

interface CardOptionButtonWS extends CardOptionButtonProps {
  id?: string;
}

export interface ViewSelectWorkspaceProps {
  path: string;
}

export const ViewSelectWorkspace = ({
  path
}: ViewSelectWorkspaceProps): React.ReactElement<ViewSelectWorkspaceProps> => {
  const history = useHistory();
  const { workspaces } = React.useContext(AppOptionsContext);
  const { subscriptionsSummary } = React.useContext(SubscriptionContext);

  // TODO: path condition added for NEXUS
  const cards: CardOptionButtonWS[] =
    workspaces &&
    path !== '/app/agency-reports' &&
    path !== '/app/my-reports' &&
    path !== '/app/collaborated-reports'
      ? workspaces.map((workspace) => ({
          id: workspace.id,
          label: workspace.name,
          icon: 'Done-Task',
          onClick: () => history.push(`${path}/workspaces/${workspace.id}`)
        }))
      : [];

  if (subscriptionsSummary.appPlan.cc) {
    cards.push({
      label: 'Contacts',
      icon: 'Open-Hand-1',
      onClick: () => history.push(`${path}/contacts`)
    });
  }

  cards.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <CardOptionsView>
      {cards.map((card) => (
        <CardOptionButton
          key={`${card.label}${card.id ? '-' + card.id : ''}`}
          label={card.label}
          icon={card.icon}
          onClick={card.onClick}
        />
      ))}

      {/* If there is no workspaces subscription, show a default card at the end */}
      {!subscriptionsSummary.appPlan.nexus && (
        <CardOptionWorkspaceAds key={`WorkspacesAds`} />
      )}
    </CardOptionsView>
  );
};
